export const SubscriptionType = Object.freeze({
    FreeTrial: 'FREE_TRIAL',
    LitePlan: 'LITE_PLAN',
    PremiumPlan: 'PREMIUM_PLAN',
    EnterprisePlan: 'ENTERPRISE_PLAN',
})
